module.exports = __webpack_public_path__ + "static/media/round-done-button.decbfb4a.svg";